import { mutate } from 'swr'

import {
  patchJson,
  postJson,
  putJson,
  requestDelete,
} from '../../../data/fetchers'
import {
  AllowanceCharge,
  Attachment,
  Invoice,
  InvoiceItem,
  PatchRequest,
  TermOfPayment,
  WebEdiDto,
} from '../../../data/models'

// patchInvoice
export async function requestPatchInvoiceById(
  invoiceId: string,
  invoiceDto: PatchRequest<WebEdiDto<Invoice>>,
): Promise<any> {
  const result = await patchJson(`/Invoices/${invoiceId}`, invoiceDto)

  // HACK: Should be called in components in order to make OptimisticUi possible
  mutate((key: string) =>
    key.toLowerCase().startsWith(`/Invoices/${invoiceId}`.toLowerCase()),
  )

  return result
}

// completeInvoice
export async function requestCompleteInvoiceById(
  invoiceId: string,
  invoiceDto: PatchRequest<WebEdiDto<Invoice>>,
): Promise<any> {
  return await patchJson(`/Invoices/${invoiceId}/complete`, invoiceDto)
}

// put InvoiceItem
export async function requestPutInvoiceItemById(
  invoiceId: string,
  itemId: string,
  invoiceDto: InvoiceItem,
): Promise<any> {
  const result = await putJson(
    `/Invoices/${invoiceId}/Items/${itemId}`,
    invoiceDto,
  )

  // HACK: Should be called in components in order to make OptimisticUi possible
  mutate((key: string) =>
    key.toLowerCase().startsWith(`/Invoices/${invoiceId}`.toLowerCase()),
  )

  return result
}

// post AllowanceCharges
export async function requestPostAllowanceChargesById(
  invoiceId: string,
  dto: AllowanceCharge,
): Promise<any> {
  const result = await postJson(`/Invoices/${invoiceId}/AllowanceCharges`, dto)

  // HACK: Should be called in components in order to make OptimisticUi possible
  mutate((key: string) =>
    key.toLowerCase().startsWith(`/Invoices/${invoiceId}`.toLowerCase()),
  )

  return result
}

// put AllowanceCharges
export async function requestPutAllowanceChargesById(
  invoiceId: string,
  id: string,
  dto: AllowanceCharge,
): Promise<any> {
  const result = await putJson(
    `/Invoices/${invoiceId}/AllowanceCharges/${id}`,
    dto,
  )

  // HACK: Should be called in components in order to make OptimisticUi possible
  mutate((key: string) =>
    key.toLowerCase().startsWith(`/Invoices/${invoiceId}`.toLowerCase()),
  )

  return result
}

// post ItemAllowanceCharges
export async function requestPostItemAllowanceChargesById(
  invoiceId: string,
  itemId: string,
  dto: AllowanceCharge,
): Promise<any> {
  const result = await postJson(
    `/Invoices/${invoiceId}/Items/${itemId}/AllowanceCharges`,
    dto,
  )

  // HACK: Should be called in components in order to make OptimisticUi possible
  mutate((key: string) =>
    key.toLowerCase().startsWith(`/Invoices/${invoiceId}`.toLowerCase()),
  )

  return result
}

// put ItemAllowanceCharges
export async function requestPutItemAllowanceChargesById(
  invoiceId: string,
  itemId: string,
  id: string,
  dto: AllowanceCharge,
): Promise<any> {
  const result = await putJson(
    `/Invoices/${invoiceId}/Items/${itemId}/AllowanceCharges/${id}`,
    dto,
  )

  // HACK: Should be called in components in order to make OptimisticUi possible
  mutate((key: string) =>
    key.toLowerCase().startsWith(`/Invoices/${invoiceId}`.toLowerCase()),
  )

  return result
}

// post TermsOfPayment
export async function requestPostTermsOfPaymentById(
  invoiceId: string,
  dto: TermOfPayment,
): Promise<any> {
  const result = await postJson(`/Invoices/${invoiceId}/TermsOfPayments`, dto)

  // HACK: Should be called in components in order to make OptimisticUi possible
  mutate((key: string) =>
    key.toLowerCase().startsWith(`/Invoices/${invoiceId}`.toLowerCase()),
  )

  return result
}

// put TermsOfPayment
export async function requestPutTermsOfPaymentById(
  invoiceId: string,
  id: string,
  dto: TermOfPayment,
): Promise<any> {
  const result = await putJson(
    `/Invoices/${invoiceId}/TermsOfPayments/${id}`,
    dto,
  )

  // HACK: Should be called in components in order to make OptimisticUi possible
  mutate((key: string) =>
    key.toLowerCase().startsWith(`/Invoices/${invoiceId}`.toLowerCase()),
  )

  return result
}

// delete TermsOfPayment
export async function requestDeleteTermsOfPaymentById(
  invoiceId: string,
  id: string,
): Promise<any> {
  const result = await requestDelete(
    `/Invoices/${invoiceId}/TermsOfPayments/${id}`,
  )

  // HACK: Should be called in components in order to make OptimisticUi possible
  mutate((key: string) =>
    key.toLowerCase().startsWith(`/Invoices/${invoiceId}`.toLowerCase()),
  )

  return result
}

export async function requestAttachmentUpload(
  invoiceId: string,
  processId: string,
  attachment: { attachment: File; category: string },
  checkwithai: boolean = false,
) {
  const { attachment: file, category } = attachment

  const attObj: Omit<Attachment, 'Id'> = {
    Name: file.name,
    Type: 'additional',
    Category: category,
    MimeType: file.type,
  }

  const formData = new FormData()
  formData.append('processId', processId)
  formData.append('file', file)
  formData.append('attachment', JSON.stringify(attObj))

  const result = await postJson(
    `/Invoices/${invoiceId}/Attachments?checkwithai=${checkwithai}`,
    formData,
  )

  // HACK: Should be called in components in order to make OptimisticUi possible
  mutate((key: string) =>
    key.toLowerCase().startsWith(`/Invoices/${invoiceId}`.toLowerCase()),
  )

  return result
}

export async function requestAttachmentDelete(
  invoiceId: string,
  attachmentId: string,
  attachmentUri: string,
) {
  const result = await requestDelete(
    `/Invoices/${invoiceId}/Attachments/${attachmentId}`,
    {
      'Xia-AttachmentUri': encodeURI(attachmentUri),
    },
  )

  // HACK: Should be called in components in order to make OptimisticUi possible
  mutate((key: string) =>
    key.toLowerCase().startsWith(`/Invoices/${invoiceId}`.toLowerCase()),
  )

  return result
}
